import { render, staticRenderFns } from "./swiper-item.vue?vue&type=template&id=574809bb&scoped=true&lang=pug"
import script from "./swiper-item.vue?vue&type=script&lang=ts"
export * from "./swiper-item.vue?vue&type=script&lang=ts"
import style0 from "./swiper-item.vue?vue&type=style&index=0&id=574809bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574809bb",
  null
  
)

export default component.exports